module.exports = __webpack_public_path__ + "static/media/acceleration-tests.1c0af8c1.png";